const maximize = () => {
    window.WC._sessionStorage.set('closerState', 'maximized');
    window.closer.openWidget();
};

export default maximize;
